var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { attrs: { title: _vm.name } }, [
    _vm._v(
      "\n  " +
        _vm._s(
          _vm.name.length > _vm.maxLength
            ? `${_vm.name.slice(0, _vm.maxLength)}...`
            : _vm.name
        ) +
        "\n"
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }